export default "__VITE_ASSET__2qvaM2Eo__";